<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template> 
<div>
       <InfoOrder :text="text" :orderType="orderType"></InfoOrder>
       <br>
       <SumOrders ref="SumOrders"></SumOrders>
   
    <div id="data-list-thumb-view" class="data-list-container">
      <vs-table
        ref="tableConfirmed"
        v-model="confirmedProducts"
        pagination
        :max-items="itemsPerPageConfirmed"
        search
        :data="selectedUniq"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="flex flex-wrap-reverse items-center"></div>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * itemsPerPageConfirmed -
                    (itemsPerPageConfirmed - 1)
                }}
                -
                {{
                  selectedUniq.length - currentPage * itemsPerPageConfirmed > 0
                    ? currentPage * itemsPerPageConfirmed
                    : selectedUniq.length
                }}
                of {{ queriedItemsConfirmed }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPageConfirmed = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPageConfirmed = 20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead" >
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="code">Código</vs-th>
          <vs-th sort-key="code">Último Preço (Cliente)</vs-th>
          <vs-th sort-key="code">Categoria</vs-th>
          <vs-th sort-key="category">Quantidade</vs-th>
          <vs-th sort-key="category">Valor Unitario</vs-th>
          <vs-th sort-key="category">Valor Total</vs-th>
          <vs-th sort-key="category">Remover</vs-th>
        </template>

        <template slot-scope="{ data }" >
          <tbody>
            <vs-tr
              :data="product"
              :key="indextr"
              v-for="(product, indextr) in data"
            >
              <vs-td>
                <p class="product-name font-medium">
                  {{ product.name }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.code }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  <vs-chip color="success" v-show="product.priceItemOrder">{{ product.priceItemOrder }}</vs-chip>
                </p>
              </vs-td>
              <vs-td v-if="product.category == 'EQUIPAMENTOS'">
                <vs-chip color="success">{{ product.category }}</vs-chip>
              </vs-td>
              <vs-td v-if="product.category == 'SUPRIMENTOS'">
                <vs-chip color="warning">{{ product.category }}</vs-chip>
              </vs-td>
              <vs-td v-if="product.category == 'PEÇAS'">
                <vs-chip color="primary">{{ product.category }}</vs-chip>
              </vs-td>

              <vs-td>
                <vs-input-number
                  v-model="product.amount"
                  @input="handleInput"
                />
              </vs-td>
              <vs-td>
                <vs-input
                  v-model="product.price"
                  @input="handleInput"
                  v-currency="{ currency: 'BRL', locale: 'pt-br' }"
                />
              </vs-td>
              <vs-td>
                <vs-chip color="primary">{{
                  sum(product.amount, product.price)
                }}</vs-chip>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(product.idProduct)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <div id="data-list-thumb-view" class="data-list-container">
      <vs-table
        ref="table"
        v-model="selected"
        pagination
        :max-items="10"
        search
        :data="getProducts"
        multiple
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div class="flex flex-wrap-reverse items-center"></div>
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                {{
                  getProducts.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : getProducts.length
                }}
                of {{ queriedItems }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 30">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th>Foto</vs-th>
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="code">Código</vs-th>
          <vs-th sort-key="category">Categoria</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr
              :data="product"
              :key="indextr"
              v-for="(product, indextr) in data"
            >
              <vs-td class="img-container">
                <!--<img :src="imgBlob" class="product-img" />-->
                <div v-lazy-container="{ selector: 'img' }">
                  <img
                    key="onlineImg"
                    v-bind:data-src="product.photoProduct"
                    alt="product-img"
                    width="100"
                    height="100"
                    class="product-img rounded-none shadow-md cursor-pointer block"
                  />
                </div>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">
                  {{ product.name }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ product.code }}
                </p>
              </vs-td>
              <vs-td v-if="product.category == 'EQUIPAMENTOS'">
                <vs-chip color="success">{{ product.category }}</vs-chip>
              </vs-td>
              <vs-td v-if="product.category == 'SUPRIMENTOS'">
                <vs-chip color="warning">{{ product.category }}</vs-chip>
              </vs-td>
              <vs-td v-if="product.category == 'PEÇAS'">
                <vs-chip color="primary">{{ product.category }}</vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>

import { numberJS } from "@/helpers";
import SumOrders from './SumOrders'
import InfoOrder from './InfoOrder'
export default {
  components: {SumOrders,InfoOrder},
  props: {
    data: {
      type: Array,
      default: () => []
    },
    orderType: {
      type: String,
    },
    text: {
      type: String,
    },
    endpointType: {
      type: String,
    }

  },
  data() {
    return {
      selected: this.data,
      products: [],
      confirmedProducts: [],
      itemsPerPageConfirmed: 10,
      itemsPerPage: 30,
      isMounted: false,
      activeAlert: false,
      path: null,
    };
  },
  computed: {
    selectedUniq: {
      get: function() {
        const uniqSelected = _.uniqBy(this.selected, "idProduct");
        return uniqSelected;
      },
      set: function(newValue) {}
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItemsConfirmed() {
      return this.$refs.tableConfirmed
        ? this.$refs.tableConfirmed.queriedResults.length
        : this.selectedUniq.length;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.getProducts.length;
    },
    getProducts() {
      //console.log(this.$store.state.products) para testes
      return _.cloneDeep(this.$store.state.products);
    }
  },
  methods: {
    handleInput() {
      this.$refs.SumOrders.getProducts(this.selectedUniq);
      this.$emit("selectProducts", this.selectedUniq);
    },
    deleteData(idProduct) {
      const productIndex = this.selected.findIndex(
        p => p.idProduct == idProduct
      );
      this.selected.splice(productIndex, 1);
      this.$emit("selectProducts", this.selectedUniq);
      this.$refs.SumOrders.getProducts(this.selectedUniq);
    },
     sum(amount,price){
      let newPrice = numberJS().getNumber(price)
      let newAmount = numberJS().getNumber(amount)
      let total = +(newPrice * newAmount)
      return total = numberJS().formatBRL(total)
    },
    getOrderStatusColor(status) {
      if (status == "on_hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    }
  },
  async created() {
    console.log(this.endpointType)
   
    let payload = {
      loading: this.$vs.loading,
      idOrder: this.idOrder,
      typeOrder: this.endpointType
    };

    //console.log(payload) para testes

    this.$store.dispatch("fetchProductsItems", payload);
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>